import React from 'react'

// PublicOnly simplificado: não redireciona automaticamente.
// Mantemos a rota de login sempre acessível; o fluxo de pós-login
// faz o redirecionamento.
export default function PublicOnly({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
